(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/utils/constants.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/utils/constants.js');
"use strict";


const MAX_GREETING_LENGTH = 200;
const MAX_LINE_BREAKS = 11;
setGlobal('svs.ticketsOrderHome.utils.constants', {
  orderHomeMessage: {
    TITLE: 'Skicka med en hälsning',
    INVALID_EMOJI_INPUT_ERROR: 'Tillåtna tecken: A-Ö a-ö 0-9 !?.,;:-_()<>^',
    GREETING_LABEL: 'Din hälsning (kan lämnas tomt)',
    FOOTER_TEXT: 'Om du inte vill skicka med en hälsning kan du lämna fältet ovan tomt.',
    MAX_GREETING_LENGTH,
    MAX_GREETING_LENGTH_MESSAGE: "H\xE4lsningen \xE4r f\xF6r l\xE5ng {CURRENT_LENGTH}/".concat(MAX_GREETING_LENGTH, "."),
    MAX_LINE_BREAKS,
    MAX_LINE_ERROR_MESSAGE: "Du kan bara ha ".concat(MAX_LINE_BREAKS, " radbrytningar.")
  },
  orderHomeReceiver: {
    errors: {
      NO_SEARCH_RESULTS: {
        code: 6000,
        message: 'Inga sökträffar. Försök igen med andra sökord.'
      },
      TOO_MANY_SEARCHES: {
        code: 6100,
        message: 'Du har gjort för många sökningar. Vänligen försök igen senare.'
      },
      INPUT_VALIDATION_FAILED: {
        code: 6200,
        message: 'Ogiltig sökning. Försök igen med andra sökord.'
      },
      TOO_MANY_SEARCH_RESULTS: {
        code: 6400,
        message: 'För många sökträffar. Försök att vara mer specifik i din sökning.'
      },
      UNKNOWN_ERROR: {
        code: 6500,
        message: 'Ett fel inträffade under sökningen. Vänligen försök igen senare.'
      }
    }
  },
  orderHomePreviewCoverLetter: {
    TITLE: 'Min present',
    EDIT_BTN_LABEL: 'Ändra hälsning'
  },
  orderHomeConfirmation: {
    GIFT: {
      TITLE: 'Klart!',
      MESSAGE: 'Din present är nu på väg till {RECEIVER_NAME}.',
      MESSAGE_NO_NAME: 'Din present är nu på väg'
    },
    HOME: {
      TITLE: 'Tack för din beställning!'
    }
  },
  SHIPPING_COST: 10,
  ContactInfoStatus: {
    DELETED: '0',
    BOUNCE: '1',
    VERIFIED: '2',
    OFFERED_VERIFICATION_ACTIVE: '3',
    NOT_OFFERED_VERIFICATION: '4',
    OFFERED_VERIFICATION_EXPIRED: '5' 
  },
  OrderStatus: {
    INITIALIZED: 'Initialized',
    PENDING: 'Pending',
    CREATED_AT_EXTERNAL_PARTNER: 'CreatedAtExternalPartner',
    CANCELLED: 'Cancelled',
    COMMITTED: 'Committed'
  },
  OrderType: {
    HOME: 0,
    GIFT: 1
  },
  MINIMUM_TOTAL_ORDER_PRICE: 100,
  MAXIMUM_TOTAL_QUANTITY_WEIGHT: 20,
  productCodeMap: {
    11: {
      name: 'SkrapBingo 30 kr (11)',
      quantityWeight: 1
    },
    13: {
      name: 'TrissPaket 150 kr (13)',
      quantityWeight: 2
    },
    20: {
      name: 'SkrapKeno 30 kr (20)',
      quantityWeight: 1
    },
    21: {
      name: 'SkrapBingo 30 kr (21)',
      quantityWeight: 1
    },
    23: {
      name: 'Triss Jubileumslott 100 kr (23)',
      quantityWeight: 1
    },
    28: {
      name: 'Triss 40 kr (28)',
      quantityWeight: 1
    },
    33: {
      name: 'SkrapKryss 30 kr (33)',
      quantityWeight: 1
    },
    34: {
      name: 'BilTriss 40 kr (34)',
      quantityWeight: 1
    },
    35: {
      name: 'SkrapKryss 30 kr (35)',
      quantityWeight: 1
    },
    37: {
      name: 'Triss Nyårskalender - 300 kr (37)',
      quantityWeight: 2
    },
    43: {
      name: 'Triss Adventskalender - 150 kr (43)',
      quantityWeight: 2
    },
    44: {
      name: 'DubbelTriss 60 kr (44)',
      quantityWeight: 1
    },
    46: {
      name: 'God jul paket 150 kr (46)',
      quantityWeight: 2
    },
    49: {
      name: 'Triss Adventskalender - 75 kr (49)',
      quantityWeight: 2
    },
    50: {
      name: 'Triss 30 kr (50)',
      quantityWeight: 1
    },
    53: {
      name: 'MiniTriss 10 kr (53)',
      quantityWeight: 1
    },
    54: {
      name: 'DubbelTriss 60 kr (54)',
      quantityWeight: 1
    },
    55: {
      name: 'Triss 30 kr (55)',
      quantityWeight: 1
    },
    57: {
      name: 'MiniTriss 10 kr (57)',
      quantityWeight: 1
    },
    60: {
      name: 'Triss 30 kr (60)',
      quantityWeight: 1
    }
  }
});

 })(window);